module.exports = __webpack_public_path__ + "static/media/Pool-seating.8330249f.jpg";